var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('GestioneMacchinari')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }